import moment from "moment";

export enum enumFloatingDates {
	today = "today",
	yesterday = "yesterday",
	last_two_days = "last_two_days",
	this_week = "this_week",
	last_seven_days = "last_seven_days",
	last_week = "last_week",
	this_month = "this_month",
	last_30_days = "last_30_days",
	last_month = "last_month",
	last_3_months = "last_3_months",
	last_6_months = "last_6_months",
	last_13_months = "last_13_months",
	this_year = "this_year",
	last_year = "last_year"
}
export const floating_dates_list = [
	{ label: "Today", value: enumFloatingDates.today },
	{ label: "Yesterday", value: enumFloatingDates.yesterday },
	{ label: "This Week", value: enumFloatingDates.this_week },
	{ label: "Last Week", value: enumFloatingDates.last_week },
	{ label: "This Month", value: enumFloatingDates.this_month },
	{ label: "Last Month", value: enumFloatingDates.last_month },
	{ label: "This Year", value: enumFloatingDates.this_year },
	{ label: "Last Year", value: enumFloatingDates.last_year }
];

export const getDateRange = (interval: enumFloatingDates, format = "YYYY-MM-DD") => {
	let start;
	let end;

	switch (interval) {
		case enumFloatingDates.yesterday:
			start = moment().subtract(1, "day").startOf("day");
			end = moment().subtract(1, "day").endOf("day");
			break;
		case enumFloatingDates.today:
			start = moment().startOf("day");
			end = moment().endOf("day");
			break;
		case enumFloatingDates.last_two_days:
			start = moment().subtract(1, "days").startOf("day");
			end = moment().endOf("day");
			break;
		case enumFloatingDates.this_week:
			start = moment().startOf("week");
			end = moment().endOf("week");
			break;

		case enumFloatingDates.last_seven_days:
			start = moment().subtract(7, "days").startOf("day");
			end = moment().endOf("day");
			break;

		case enumFloatingDates.last_week:
			start = moment().subtract(1, "week").startOf("week");
			end = moment().subtract(1, "week").endOf("week");
			break;

		case enumFloatingDates.this_month:
			start = moment().startOf("month");
			end = moment().endOf("month");
			break;

		case enumFloatingDates.last_30_days:
			start = moment().subtract(30, "days").startOf("day");
			end = moment().endOf("day");
			break;
		case enumFloatingDates.last_month:
			start = moment().subtract(1, "month").startOf("month");
			end = moment().subtract(1, "month").endOf("month");
			break;

		case enumFloatingDates.last_3_months:
			start = moment().subtract(3, "months").startOf("day");
			end = moment().endOf("day");
			break;

		case enumFloatingDates.last_6_months:
			start = moment().subtract(6, "months").startOf("day");
			end = moment().endOf("day");
			break;

		case enumFloatingDates.this_year:
			start = moment().startOf("year");
			end = moment().endOf("year");
			break;

		case enumFloatingDates.last_year:
			start = moment().subtract(1, "year").startOf("year");
			end = moment().subtract(1, "year").endOf("year");
			break;

		case enumFloatingDates.last_13_months:
			start = moment().subtract(13, "months").startOf("day");
			end = moment().endOf("day");
			break;

		default:
			// Invalid interval
			return null;
	}

	// Format the start and end dates as "yyyymmdd"
	const start_date = start.format(format);
	const end_date = end.format(format);

	return { start_date, end_date };
};
